import { ColDef } from '@ag-grid-enterprise/all-modules'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'

export const batchActionsSampleColumnDefs =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('diagnosis.grid.caseGrid.casCasenumber'),
            colId: 'caseStudy.casCasenumber',
            field: 'caseStudy.caseNumber',
            width: 150,
            minWidth: 140,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.DATETIME,
            headerName: i18n.tc('diagnosis.grid.caseGrid.casRegistrationDate'),
            colId: 'caseStudy.casRegistrationDate',
            field: 'caseStudy.registrationDate',
            width: 150,
            minWidth: 140,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('diagnosis.grid.caseGrid.pathologist'),
            colId: 'caseStudy.pathologist.normalizedFullName',
            field: 'caseStudy.pathologist.fullName',
            width: 150,
            minWidth: 140,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('diagnosis.grid.sampleGrid.specialist'),
            colId: 'specialist.normalizedFullName',
            field: 'specialist.fullName',
            width: 150,
            minWidth: 140,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('diagnosis.grid.sampleGrid.samSamplenumber'),
            colId: 'samLabel',
            field: 'label',
            width: 150,
            minWidth: 140,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('diagnosis.grid.sampleGrid.sampleType'),
            field: 'sampleType.description',
            width: 150,
            minWidth: 140,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('diagnosis.grid.sampleGrid.location'),
            field: 'topographicCode.description',
            width: 150,
            minWidth: 140,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('diagnosis.grid.sampleGrid.procedure'),
            field: 'procedure.description',
            width: 150,
            minWidth: 140,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('diagnosis.grid.sampleGrid.mostLikelyDiagnosis'),
            field: 'mostLikelyMorphologicCode.description',
            width: 150,
            minWidth: 140,
            suppressSizeToFit: true
        }
    ]
